import { RouterProvider } from "react-router-dom";
import moment from "moment";

import "react-phone-input-2/lib/style.css";
import "./App.scss";
import router from "./router/router";

moment.updateLocale("en", {
  week: {
    dow: 1,
  },
});

function App() {
  return (
    <div className="App">
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
